module.exports = __webpack_public_path__ + "img/a11y-contraste.2eb3453f.svg";